var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBullet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 5.5,
    stroke: "#EB662B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.05642 6.50033L5.88976 8.33366L8.94531 4.66699",
    stroke: "#EB662B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBullet);
export default __webpack_public_path__ + "static/media/check-bullet.db6abe77573fbc184da3390618382933.svg";
export { ForwardRef as ReactComponent };